module.exports = __webpack_public_path__ + "static/media/scale.fc92368d.png";